export enum DriverActivityType {
  REST = 'Rest',
  DRIVE = 'Drive',
  NOT_AVAILABLE = 'Not available',
  AVAILABLE = 'Available',
  WORK = 'Work',
  PAID_REST = 'Paid Rest',
}
